import script from "./ComplianceConfirmWriteCard.vue?vue&type=script&setup=true&lang=js"
export * from "./ComplianceConfirmWriteCard.vue?vue&type=script&setup=true&lang=js"

import "./ComplianceConfirmWriteCard.vue?vue&type=style&index=0&id=0e59a33e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0e59a33e"]])

export default __exports__